module.exports = [{
      plugin: require('/opt/build/repo/packages/landing-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
